import React, {
  createContext,
  ReactNode,
  useContext,
  useState,
} from "react";
import { Historico } from "../types/historico-interface";
import { useMutation } from '@tanstack/react-query'
import { apiModulo } from '../services/api'

interface HistoricoContextProviderProps {
  children: ReactNode;
}

interface RequestHistorico {
  url: string;
  cpf_cnpj: string;
  codcredor: string;
  contrato?: string;
  dataInicio?: string;
  dataFim?: string;
  app?: string;
  usuario?: string
}

interface HistoricoContextProps {
  getHistorico(data: RequestHistorico): Promise<void>
  clearHistorico(): void
  historico: Historico
}

const HistoricoContext = createContext<HistoricoContextProps>({} as HistoricoContextProps);

export const HistoricoProvider = ({ children }: HistoricoContextProviderProps) => {
  const [historico, setHistorico] = useState<Historico>({} as Historico)

  const mHistorico = useMutation({
    mutationFn: (data: RequestHistorico) => apiModulo.post('/history', { ...data, app: data?.app || 'ACIONA_WEB' }), mutationKey: ['form']
  })

  async function getHistorico(data: RequestHistorico) {
    const { data: response } = await mHistorico.mutateAsync(data)
    let hist = response.message
    if (!Array.isArray(hist?.acionamentos?.acionamento)) {
      hist.acionamentos.acionamento = [hist?.acionamentos?.acionamento]
    }
    setHistorico(hist)
  }

  function clearHistorico() {
    setHistorico({} as Historico)
  }

  return (
    <HistoricoContext.Provider value={{
      getHistorico, historico, clearHistorico
    }}>
      {children}
    </HistoricoContext.Provider>
  );
};

export const useHistorico = () => useContext(HistoricoContext);
